import './style.scss';

export function location_details_block() {
    const block = document.querySelector('.location_details_block');
    if (!block) return;
}
